/* eslint-disable react/no-danger */
import React from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import ActionBar from '../../../components/actionBar';

function WelcomeEverydoggy() {
  const { T } = useT();
  return (
    <div className={s.descriptionV2}>
      <div className={s.descriptionV2_bgs}>
        <div className={s.descriptionV2_bg1} />
        <div className={s.descriptionV2_bg2} />
      </div>
      <div className={s.descriptionV2_text}>
        <div
          className={s.descriptionV2_title}
          dangerouslySetInnerHTML={{ __html: T('customV1_descriptionV2_title') }}
        />
        <div className={s.descriptionV2_description}>{T('customV1_descriptionV2_description')}</div>
      </div>
      <ActionBar currentStepCompleted show withShadow />
    </div>
  );
}

export default WelcomeEverydoggy;
